<template>
  <el-dialog
    append-to-body
    width="800px"
    title="处理退款"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
  >
    <el-dialog
      append-to-body
      width="400px"
      :title="title2"
      :visible.sync="visible2"
      :before-close="reset2"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div class="content2">
        <el-form
          ref="form"
          :model="form"
          label-width="auto"
          :rules="form.rules"
        >
          <template v-if="title2 == '同意退款'">
            <template v-if="info.type == 2">
              <el-form-item label="打款金额:" prop="amount">
                <el-input v-model="form.amount" placeholder="请输入" disabled>
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="打款凭证:" prop="image">
                <el-upload
                  :limit="1"
                  class="upload-demo"
                  :on-exceed="handleExceed"
                  action="/api/common/qiniu/uploadFile"
                  :headers="{ token: token }"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleRemove"
                  :before-upload="beforeAvatarUpload"
                  ref="uploadInvoiceDom"
                  :file-list="form.fileList"
                  accept="image/jpeg, image/png, image/gif, .pdf, .xlsx, .xls "
                >
                  <el-button type="primary">请上传</el-button>
                </el-upload>
              </el-form-item>
            </template>
            <template v-else>
              <div v-if="info.work_status != 1">
                <div style="text-align: center">是否扣除企业服务费 ¥500</div>
                <div style="text-align: center">({{ info.company_name }})</div>
                <el-form-item label="" label-width="100px">
                  <el-radio :label="1" v-model="is_deduct">扣除</el-radio>
                  <el-radio :label="2" v-model="is_deduct">无需扣除</el-radio>
                </el-form-item>
              </div>
            </template>
            <!-- <div style="text-align: center">确认后款项将为用户原路退回</div> -->
          </template>
          <template v-else>
            <el-form-item label="拒绝原因:" prop="rejectReson">
              <el-input
                type="textarea"
                v-model="form.rejectReson"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="lastSubmit">确定</el-button>
      </span>
    </el-dialog>
    <div class="content">
      <el-descriptions
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="订单信息"
        :column="1"
        border
        style="margin-bottom: 10px"
      >
        <template v-if="info.type == 2">
          <el-descriptions-item label="名称">{{
            info.company_name
          }}</el-descriptions-item>
          <el-descriptions-item label="账号">{{
            info.account
          }}</el-descriptions-item>
          <el-descriptions-item label="充值端口"> 企业端 </el-descriptions-item>
          <el-descriptions-item label="订单类型">{{
            toStr({ 1: "人才币", 2: "保证金", 3: "诚信保" }, info.type)
          }}</el-descriptions-item>
          <el-descriptions-item label="总支付金额"
            >{{ info.amount }}元</el-descriptions-item
          >
          <el-descriptions-item label="扣款金额" v-if="info.type != 3"
            >{{ info.amount - info.refund_amount }}元</el-descriptions-item
          >
          <el-descriptions-item label="退款原因" v-if="info.type == 3">{{
            info.work_status == 1 ? "入职满10天" : "已离职"
          }}</el-descriptions-item>
        </template>
        <template v-if="info.type == 3">
          <el-descriptions-item label="名称">{{
            info.nickname
          }}</el-descriptions-item>
          <el-descriptions-item label="账号">{{
            info.account
          }}</el-descriptions-item>
          <el-descriptions-item label="充值端口"> 求职端 </el-descriptions-item>
          <el-descriptions-item label="订单类型">{{
            toStr({ 1: "人才币", 2: "保证金", 3: "诚信保" }, info.type)
          }}</el-descriptions-item>
          <el-descriptions-item label="支付金额"
            >{{ info.amount }}元</el-descriptions-item
          >
          <el-descriptions-item label="支付渠道">{{
            toStr({ 1: "微信", 2: "支付宝" }, info.pay_type)
          }}</el-descriptions-item>
          <el-descriptions-item label="交易流水号">{{
            info.order_no
          }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{
            info.pay_time
          }}</el-descriptions-item>
        </template>
      </el-descriptions>
      <!-- 企业端 -->
      <el-descriptions
        v-if="info.type == 2"
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="退款信息"
        :column="1"
        border
      >
        <el-descriptions-item label="申请时间">
          {{ info.apply_time }}
        </el-descriptions-item>
        <el-descriptions-item label="退款金额">
          {{ info.refund_amount }}
        </el-descriptions-item>
        <el-descriptions-item label="退款原因">{{
          info.refund_reason
        }}</el-descriptions-item>
        <el-descriptions-item label="补充描述">{{
          info.apply_desc
        }}</el-descriptions-item>
        <el-descriptions-item label="收款名称">{{
          info.company_name
        }}</el-descriptions-item>
        <el-descriptions-item label="银行账号">{{
          info.bank_code
        }}</el-descriptions-item>
        <el-descriptions-item label="开户银行">{{
          info.bank_name
        }}</el-descriptions-item>
      </el-descriptions>
      <!-- 求职端  找到工作全额退-->
      <el-descriptions
        v-if="info.type == 3 && info.company_name"
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="退款信息"
        :column="1"
        border
      >
        <el-descriptions-item label="申请时间">
          {{ info.apply_time }}
        </el-descriptions-item>
        <el-descriptions-item label="入职企业">{{
          info.company_name
        }}</el-descriptions-item>
        <el-descriptions-item label="入职日期">{{
          info.entry_date
        }}</el-descriptions-item>
        <el-descriptions-item label="扣款金额" v-if="info.type != 3"
          >{{ info.amount - info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item label="退款原因" v-if="info.type == 3">{{
          info.work_status == 1 ? "入职满10天" : "已离职"
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额"
          >{{ info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item
          :label="info.work_status == 1 ? '入职凭证' : '离职凭证'"
        >
          <el-image
            v-for="(item, index) in info.refund_img"
            :key="index"
            style="width: 100px; height: 100px"
            :src="item"
            :preview-src-list="info.refund_img"
          >
          </el-image>
          <!-- <el-dropdown
            trigger="click"
            placement="bottom"
            @command="handleCommand($event, info)"
          >
            <span style="cursor: pointer; color: #409eff">
              {{ info.refund_img.length }}张
            </span>
            <el-dropdown-menu
              slot="dropdown"
              v-if="info.refund_img && info.refund_img.length"
            >
              <el-dropdown-item
                v-for="(item, index) in info.refund_img"
                :command="index"
                :key="index"
                >凭证{{ index + 1 }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown> -->
        </el-descriptions-item>
      </el-descriptions>
      <!-- 求职端  没找到工作按天扣费，退还剩余部分-->
      <el-descriptions
        v-if="info.type == 3 && !info.company_name"
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="退款信息"
        :column="1"
        border
      >
        <el-descriptions-item label="申请时间">
          {{ info.apply_time }}
        </el-descriptions-item>
        <el-descriptions-item label="使用天数"
          >{{ info.days }}天</el-descriptions-item
        >
        <el-descriptions-item label="扣款金额" v-if="info.type != 3"
          >{{ info.amount - info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item label="退款金额"
          >{{ info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item label="退款原因">{{
          info.refund_reason
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <span slot="footer">
      <el-button @click="reject">拒绝退款</el-button>
      <el-button @click="agree" type="primary">同意退款</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getStorage } from "@/storage";
import { checkAmount_ } from "@/util/validator.js";
export default {
  name: "handleRefundDialog",
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      visible2: false,
      loading: false,
      label_style: {
        width: "20%",
      },
      content_style: {
        width: "80%",
      },
      title2: "",
      form: {
        rejectReson: "",
        amount: "",
        image: "",
        fileList: [],
        rules: {
          rejectReson: [
            {
              required: true,
              message: "必填",
              trigger: "change",
            },
          ],
          amount: [
            {
              required: true,
              validator: checkAmount_,
              trigger: "change",
            },
          ],
          image: [
            {
              required: true,
              message: "请上传打款凭证",
              trigger: "change",
            },
          ],
        },
      },
      //预览
      fileList: [],
      dialogImageUrl: "",
      dialogVisibleUrl: false,
      info: { type: "" },
      is_deduct: "",
    };
  },
  methods: {
    getDetail(row) {
      console.log(row, 123);
      this.info = row;
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    reject() {
      this.title2 = "拒绝退款";
      this.visible2 = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form.rejectReson = "";
        this.form.image = "";
        this.form.fileList = "";
      });
    },
    agree() {
      if (this.info.current_earnest * 1 < this.info.refund_amount * 1) {
        return this.$message.error("企业保证金退款金额小于剩余金额，请勿同意");
      }
      this.title2 = "同意退款";
      this.visible2 = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form.amount = this.info.refund_amount;
      });
    },
    reset2() {
      this.form.rejectReson = "";
      this.form.amount = "";
      this.form.image = "";
      this.form.fileList = [];
      this.$refs.form.clearValidate();
      this.visible2 = false;
    },

    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制最多只能选择 1 个文件`);
    },
    handleAvatarSuccess(event) {
      if (event.code == 1) {
        let list = this.$refs.uploadInvoiceDom.uploadFiles;
        let urlListSuccess = list.filter((i) => i.status == "success");
        let yetList = urlListSuccess.map((item) => item.response);
        this.form.image = yetList.map((item) => {
          return {
            url: item.data.all_path_url,
            name: item.data.name,
          };
        });
        this.$refs.form.clearValidate(["image"]); // 清除 username 字段的校验状态，但不重置值
      } else {
        this.$message({
          type: "error",
          message: event.msg,
        });
      }
    },
    handleRemove() {
      this.form.image = "";
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制最多只能选择1个文件`);
    },
    lastSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let img = this.form.image
            ? this.form.image.map((item) => item.url).join(",")
            : "";
          let params = {
            id: this.info.id,
            status: this.title2 == "同意退款" ? 1 : 2,
            type: this.info.type,
            refuse_desc: this.form.rejectReson,
            refund_img: img,
            is_deduct: this.is_deduct,
          };
          if (params.status == 1) {
            if (
              this.info.work_status != 1 &&
              !this.is_deduct &&
              this.info.type == 3
            )
              return this.$message.error("请选择是否扣除企业服务费");
            this.$http.post("/admin/order/operation", params).then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功");
                this.is_deduct = "";
                this.toggle(false);
                this.visible2 = false;
                this.$emit("update");
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$confirm(`请确认${this.title2}?`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }).then(() => {
              this.$http.post("/admin/order/operation", params).then((res) => {
                if (res.code == 1) {
                  this.$message.success("操作成功");
                  this.toggle(false);
                  this.visible2 = false;
                  this.$emit("update");
                } else {
                  this.$message.error(res.msg);
                }
              });
            });
          }
        }
      });
    },
    toStr(data, key) {
      return data[key] || "";
    },
    handleCommand(e, row) {
      window.open(row.refund_img[e]);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  overflow: auto;
}
</style>
